<template>
  <div
    :class="['avatar-wrapper', size, hasBorder ? 'hasBorder' : '']"
    v-lazy-container="{
      selector: 'img',
      error: defaultUrl,
      loading: defaultUrl,
    }"
  >
    <img class="avatar" :data-src="url" />
    <img
      v-if="hasCrown"
      :class="['crown', 'crown' + crownNo]"
      :data-src="
        require(`@/assets/images/activities/ranking/crown-${crownNo}.png`)
      "
    />
  </div>
</template>
<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'middle',
      },
      hasBorder: {
        type: Boolean,
        default: true,
      },
      hasCrown: {
        type: Boolean,
        default: true,
      },
      crownNo: {
        type: [String, Number],
        default: '1',
      },
      url: {
        type: String,
        default: require(`@/assets/images/common/icon/avatar.png`),
      },
    },
    data() {
      return {
        defaultUrl: require(`@/assets/images/common/icon/avatar.png`),
      }
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
